import React, { Component } from 'react';
import axios from 'axios';

import Thanks from '../Thanks';
import Input, { Textarea } from '../forms/input';
import Disclosure from 'rsuite/Disclosure';

class CustomProposal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
      platforms: props.platform ? [props.platform] : [],
      step: props.step,
      activePlan: 0,
      showSocialMedias: false,
      socialMediaUrls: [
        {
          id: 'url_1',
        },
      ],
      competitorsWebsite: [
        {
          id: 'website_1',
        },
      ],
      otherMainGoal: false,
      plannedMonthlyBudget: false,
      disabled: true,
      req: false,
      activePlans: [],
      emailError: false,
    };
    this.myRef = React.createRef();

    this.stepOne = React.createRef();
    this.stepTwo = React.createRef();
    this.stepTree = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.hideThanksModal = this.hideThanksModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.setDisabled = this.setDisabled.bind(this);
  }
  componentWillReceiveProps(nextProps, nextContext) {
    this.setState({ step: nextProps.step });
    // this.setState({activePlan:nextProps.activePlan})
    // this.setState({activePlans:nextProps.activePlans})
  }
  handleChange(param, value) {
    this.setDisabled();
    var formdata = this.state.formdata;
    if (param == 'have-existing-social-media') {
      if (document.querySelector('[name=have-existing-social-media-1]').checked) this.setState({ showSocialMedias: true });
      else this.setState({ showSocialMedias: false });
    }
    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
    const that = this;
    setTimeout(function () {
      that.setDisabled();
    }, 100);
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
    });
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
  }
  onSubmit(e) {
    e.preventDefault();

    var that = this;

    var form_data = new FormData();
    // social-media-pages
    let urlsSMM = [];
    document.querySelectorAll('[name=social-media-pages]').forEach(el => {
      urlsSMM.push(el.value);
    });
    // competitors-website
    let urlsComp = [];
    document.querySelectorAll('[name=competitors-website]').forEach(el => {
      urlsComp.push(el.value);
    });
    for (var key in this.state.formdata) {
      form_data.append(key, Array.isArray(this.state.formdata[key]) ? this.state.formdata[key].join(',') : this.state.formdata[key]);
    }
    form_data.append('country', this.props.country);
    form_data.append('platform', this.props.platform);
    form_data.append('social-media-pages', urlsSMM.join(' , '));
    form_data.append('competitors-website', urlsComp.join(' , '));
    form_data.append('goals', this.state.activePlans.join(' , '));
    form_data.append('other-goal', document.getElementById('other-goal').value);

    // that.props.hide();

    // that.setState({showThanks:true});

    document.body.style.overflow = 'hidden';

    axios.post('https://mailer.weprodigi.com/api/v1/smm-custom-proposal-one', form_data).then(response => {
      // that.setState({loadedThanks:true});
      window.location.href = 'https://weprodigi.com/thank-you';
      // document.body.style.overflow = 'auto';
      // document.getElementById('offer-form-smm-custom-1').reset()
      // this.setState({
      //     showSocialMedias:false,
      //     socialMediaUrls:[
      //         {
      //             id:'url_1',
      //         }
      //     ],
      //     competitorsWebsite:[
      //         {
      //             id:'website_1',
      //         }
      //     ],
      //     otherMainGoal:false,
      //     plannedMonthlyBudget:false,
      //     disabled:true,
      //     req:false,
      //     activePlans:[],
      //     emailError:false
      // })
    });
  }
  addSocialPackageInput = ind => {
    if (this.state.socialMediaUrls.length == ind + 1) {
      let elArr = Object.assign([], this.state.socialMediaUrls);
      elArr.push({
        id: 'url_' + (ind + 2),
      });
      this.setState({ socialMediaUrls: elArr });
    }
  };
  addCompetitorInput = ind => {
    if (this.state.competitorsWebsite.length == ind + 1) {
      let elArr = Object.assign([], this.state.competitorsWebsite);
      elArr.push({
        id: 'url_' + (ind + 2),
      });
      this.setState({ competitorsWebsite: elArr });
    }
  };
  setDisabled() {
    let disabled = false;
    const { step } = this.state;
    if (step == 1) {
      let companyName = document.getElementById('companyName').value;
      let companyWebsite = document.getElementById('companyWebsite').value;
      // let haveExistingSocialMedia = document.querySelector('[name=have-existing-social-media]:checked')
      // disabled =  companyName == "" ||  companyWebsite == "" || haveExistingSocialMedia == null
      disabled = companyName == '' || companyWebsite == '';
    }
    if (step == 2) {
      // let haveMonthlyBudget = document.querySelector("[name=have-monthly-budget]")
      // disabled =  activePlan == 0 || platforms.length == 0 || haveMonthlyBudget == null
      // disabled =  platforms.length == 0
    }
    this.setState({ disabled: disabled });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.step != this.state.step) {
      this.setDisabled();
    }
  }
  setPlatformsCheckbox = (name, value) => {
    let arr = this.state.platforms;
    if (!arr.includes(value)) {
      arr.push(value);
    } else {
      arr = arr.filter(function (val) {
        return val != value;
      });
    }
    this.setState({ platforms: arr, req: false });
    this.setDisabled();
  };
  hide = () => {
    // document.getElementById('offer-form-smm-custom-1').reset()
    // this.setState({formdata:{},showSocialMedias:false,
    //     socialMediaUrls:[
    //         {
    //             id:'url_1',
    //         }
    //     ],
    //     competitorsWebsite:[
    //         {
    //             id:'website_1',
    //         }
    //     ],
    //     otherMainGoal:false,
    //     plannedMonthlyBudget:false,
    //     disabled:true,
    //     req:false,
    //     activePlans:[],
    //     emailError:false})
    this.props.hide();
  };
  setActivePlansCheckbox = (name, value) => {
    let arr = this.state.activePlans;
    if (!arr.includes(value)) {
      arr.push(value);
    } else {
      arr = arr.filter(function (val) {
        return val != value;
      });
    }
    this.setState({ activePlans: arr, req: false });
    // this.props.setPackages(arr)
    this.setDisabled();
  };
  emailValidation = email => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  };
  render() {
    const { step, activePlan, disabled, platforms, activePlans } = this.state;
    return (
      <>
        <div
          className={
            'fixed z-900 bg-navbar w-full h-full left-0 top-0 right-0 bottom-0 items-center justify-center' +
            ' ' +
            (this.props.show && !this.state.showThanks ? 'flex' : 'hidden')
          }
        >
          <div className="absolute left-0 top-0 w-full h-full" onClick={this.hide} />
          <div className="relative transform w-11/12 max-w-screen-md max-h-screen-md bg-gray border border-gray-transparent rounded-5 md:scale-100">
            <div
              onClick={this.hide}
              className="absolute -right-12 -top-12 bg-purple text-white w-30 h-30 text-21 rounded-full flex items-center justify-center cursor-pointer select-none"
            >
              <span className="font-bold">X</span>
            </div>
            <div className="pb-23 px-50 max-h-600 overflow-y-auto">
              <p ref={this.stepOne} className="pt-23 text-purple uppercase text-24 text-center font-black leading-none">
                {this.props.platform + ' Marketing Proposal'}
              </p>
              <p className="text-black text-12 mt-20">
                In order to provide you with a custom and targeted SMM proposal, we need some information about your business and objectives. An email
                address is required in the form.
              </p>
              <form id="offer-form-smm-custom-1" method="POST" onSubmit={e => this.onSubmit(e)}>
                <style global jsx>{`
                  @keyframes animate-warning {
                    0% {
                      opacity: 1;
                    }
                    25% {
                      opacity: 0.5;
                    }
                    50% {
                      opacity: 1;
                    }
                    75% {
                      opacity: 0.5;
                    }
                    100% {
                      opacity: 1;
                    }
                  }
                  .animate-warning {
                    animation: animate-warning 0.6s 2 ease-in-out forwards;
                  }
                `}</style>
                <div className={`mt-20 ${step == 1 ? 'block' : 'hidden'}`}>
                  <p className={'text-16 text-purple font-bolder'}>
                    Company Name*{' '}
                    {this.state.req && !this.state.formdata['company-name'] && (
                      <span
                        className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                        style={{ verticalAlign: 'super' }}
                      >
                        This is required
                      </span>
                    )}{' '}
                  </p>
                  <div className={'w-full mt-5'}>
                    <Input
                      type="text"
                      name="company-name"
                      bg="bg-white w-full focus:outline-none"
                      id={'companyName'}
                      required={true}
                      onChange={this.handleChange}
                    />
                  </div>
                  <p className={'text-16 text-purple font-bolder mt-15'}>
                    Company Website*{' '}
                    {this.state.req && !this.state.formdata['company-website'] && (
                      <span
                        className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                        style={{ verticalAlign: 'super' }}
                      >
                        This is required
                      </span>
                    )}{' '}
                  </p>
                  <div className={'w-full mt-5'}>
                    <Input
                      type="text"
                      name="company-website"
                      bg="bg-white w-full focus:outline-none"
                      id={'companyWebsite'}
                      required={true}
                      onChange={this.handleChange}
                    />
                  </div>
                  <p className={'text-16 text-purple font-bolder mt-20 leading-none'}>Do you have existing Social Media pages?</p>
                  <div className={'flex justify-between mt-10'}>
                    <div className="form-group   w-half">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id="social-media-page-1"
                          name="have-existing-social-media-1"
                          value="Yes"
                          onChange={() => this.handleChange('have-existing-social-media', 'Yes')}
                        />
                        <label htmlFor="social-media-page-1">Yes</label>
                      </div>
                    </div>
                    <div className="form-group mr-5  ml-10 w-half">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id="social-media-page-no-1"
                          name="have-existing-social-media-1"
                          value="No"
                          onChange={() => this.handleChange('have-existing-social-media', 'No')}
                        />
                        <label htmlFor="social-media-page-no-1">No</label>
                      </div>
                    </div>
                  </div>
                  {this.state.showSocialMedias && (
                    <div className="mt-15 mb-10">
                      {this.state.socialMediaUrls.map((url, i) => {
                        return (
                          <input
                            type="text"
                            className={'mt-2 focus:outline-none focus:placeholder-transparent rounded-5 py-5 px-10 w-full'}
                            data-key={i}
                            key={url.id}
                            name={'social-media-pages'}
                            placeholder={'Social Media page’s URL'}
                            onChange={() => this.addSocialPackageInput(i)}
                          />
                        );
                      })}
                    </div>
                  )}
                  <p className={'text-16 text-purple font-bolder mt-20'}>Some information about your target audience</p>
                  <div className={'w-full mt-15'}>
                    <Textarea
                      type="text"
                      placeholder={'Age, gender, target locations, interests and etc.'}
                      name="some-information"
                      bg="resize-none bg-white w-full focus:outline-none"
                      onChange={this.handleChange}
                    />
                  </div>
                </div>
                <div ref={this.stepTwo} className={`mt-20 ${step == 2 ? 'block' : 'hidden'}`}>
                  <p className={'text-16 text-purple font-bolder mt-15'}>Please mention your competitors' websites or company names.</p>
                  <div className="">
                    {this.state.competitorsWebsite.map((url, i) => {
                      return (
                        <input
                          type="text"
                          className={'mt-10 focus:outline-none focus:placeholder-transparent rounded-5 py-5 px-10 w-full'}
                          data-key={i}
                          key={url.id}
                          name={'competitors-website'}
                          placeholder={'Competitor’s  website or name'}
                          onChange={() => this.addCompetitorInput(i)}
                        />
                      );
                    })}
                  </div>
                  <div className="mt-20">
                    <div className="grid grid-cols-1 gap-10">
                      <div>
                        <p className="text-16 text-purple font-bolder">What is your main goals for Social Media Marketing?</p>
                        <div className="mt-15 mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlansCheckbox('activePlans', 'Increase brand awareness and visibility');
                            }}
                            className={`${activePlans.includes('Increase brand awareness and visibility') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Increase brand awareness and visibility</span>
                            {activePlans.includes('Increase brand awareness and visibility') && (
                              <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                            )}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlansCheckbox('activePlans', 'Get more engagement');
                            }}
                            className={`${activePlans.includes('Get more engagement') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Get more engagement</span>
                            {activePlans.includes('Get more engagement') && (
                              <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                            )}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlansCheckbox('activePlans', 'Get more sales');
                            }}
                            className={`${activePlans.includes('Get more sales') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Get more sales</span>
                            {activePlans.includes('Get more sales') && (
                              <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                            )}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlansCheckbox('activePlans', 'Increase traffic to your website');
                            }}
                            className={`${activePlans.includes('Increase traffic to your website') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Increase traffic to your website</span>
                            {activePlans.includes('Increase traffic to your website') && (
                              <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                            )}
                          </div>
                        </div>
                        <div className="mb-10">
                          <div
                            onClick={() => {
                              this.setActivePlansCheckbox('activePlans', 'Other');
                            }}
                            className={`${activePlans.includes('Other') ? 'border-1 border-green ' : 'border-0 '} flex justify-between px-10 bg-white items-center h-36 rounded-5 cursor-pointer`}
                          >
                            <span className="text-16 leading-20">Other</span>
                            {activePlans.includes('Other') && (
                              <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/check.png" alt="check" />
                            )}
                          </div>
                        </div>
                        <div className="mb-10">
                          <input
                            type="text"
                            className={`mt-2 focus:outline-none rounded-5 py-5 px-10 w-full ${activePlans.includes('Other') ? 'block' : 'hidden'}`}
                            id={'other-goal'}
                            name={'other-goal'}
                            placeholder={'Your main goal'}
                            onChange={this.handleChange}
                          />
                        </div>
                        <p className={'text-16 text-purple font-bolder mt-20'}>Other information you might want to share with us</p>
                        <div className={'w-full mt-15'}>
                          <Textarea
                            type="text"
                            placeholder={'Main Products Description, Project Deadlines and etc.'}
                            name="some-information-other"
                            bg="resize-none bg-white w-full focus:outline-none"
                            onChange={this.handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div ref={this.stepTree} className={`mt-20 ${step == 3 ? 'block' : 'hidden'}`}>
                  <p className={'text-16 text-purple font-bolder'}>
                    Your Name *{' '}
                    {this.state.req && !this.state.formdata['name'] && (
                      <span
                        className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                        style={{ verticalAlign: 'super' }}
                      >
                        This is required
                      </span>
                    )}
                  </p>
                  <div className={'w-full mt-5'}>
                    <Input type="text" name="name" bg="bg-white w-full focus:outline-none" required={true} onChange={this.handleChange} />
                  </div>
                  <p className={'text-16 text-purple font-bolder mt-20'}>
                    Your Email *
                    {this.state.req && !this.state.formdata['email'] && (
                      <span
                        className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                        style={{ verticalAlign: 'super' }}
                      >
                        This is required
                      </span>
                    )}
                    {this.state.req && this.state.formdata['email'] && !this.emailValidation(this.state.formdata['email']) && (
                      <span
                        className="bg-green animate-warning text-white text-12 normal-case font-normal px-5 rounded-5"
                        style={{ verticalAlign: 'super' }}
                      >
                        Email is not valid
                      </span>
                    )}
                  </p>
                  <div className={'w-full mt-5'}>
                    <Input type="email" name="email" bg="bg-white w-full focus:outline-none" required={true} onChange={this.handleChange} />
                  </div>
                  <p className={'text-16 text-purple font-bolder mt-20'}>Your Phone Number</p>
                  <div className={'w-full mt-5'}>
                    <Input type="text" name="phone" bg="bg-white w-full focus:outline-none" onChange={this.handleChange} />
                  </div>
                  <p className={'text-16 text-purple font-bolder mt-20'}>What’s the best way to contact you?</p>
                  <div className="flex flex-row mt-15">
                    <div className="form-group mr-30">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id="contact-via-email-11"
                          name="contact-via"
                          value="Email"
                          onChange={() => this.handleChange('contact-via', 'Email')}
                        />
                        <label htmlFor="contact-via-email-11">Email</label>
                      </div>
                    </div>
                    <div className="form-group mr-30">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id="contact-via-phone-11"
                          name="contact-via"
                          value="Phone"
                          onChange={() => this.handleChange('contact-via', 'Phone')}
                        />
                        <label htmlFor="contact-via-phone-11">Phone</label>
                      </div>
                    </div>
                    <div className="form-group mr-30">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id="contact-via-both-11"
                          name="contact-via"
                          value="Both"
                          onChange={() => this.handleChange('contact-via', 'Both')}
                        />
                        <label htmlFor="contact-via-both-11">Both</label>
                      </div>
                    </div>
                  </div>
                  <p className={'text-16 text-black font-bolder mt-20 leading-none'}>Send NDA</p>
                  <div className={'flex justify-between mt-15'}>
                    <div className="form-group    w-half">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id="nda-yes-11"
                          name="nda"
                          value="Yes"
                          onChange={() => {
                            this.handleChange('nda', 'Yes');
                          }}
                        />
                        <label htmlFor="nda-yes-11">Yes</label>
                      </div>
                    </div>
                    <div className="form-group mr-5  ml-10 w-half">
                      <div className="radio-item">
                        <input
                          type="radio"
                          id="nda-no-11"
                          name="nda"
                          value="No"
                          onChange={() => {
                            this.handleChange('nda', 'No');
                          }}
                        />
                        <label htmlFor="nda-no-11">No</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={'w-full prev-next-part flex justify-between text-white mt-20'}>
                  <div>
                    {step == 2 && (
                      <button
                        className={'flex hover:bg-purple items-center bg-green rounded-5 px-10 py-5 text-14'}
                        type={'button'}
                        onClick={e => {
                          this.setState({ step: 1 });
                          this.stepOne.current.scrollIntoView();
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          height={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                        Previous
                      </button>
                    )}
                    {step == 3 && (
                      <button
                        className={'flex hover:bgpurple items-center bg-green rounded-5 px-10 py-5 text-14'}
                        type={'button'}
                        onClick={e => {
                          this.setState({ step: 2 });
                          this.stepOne.current.scrollIntoView();
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          height={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                        </svg>
                        Previous
                      </button>
                    )}
                  </div>
                  <div>
                    {step == 1 && (
                      <button
                        className={'flex hover:bg-purple items-center bg-green rounded-5 px-10 py-5 text-14'}
                        type={'button'}
                        onClick={e => {
                          let cName = this.state.formdata['company-name'];
                          let cWebsite = this.state.formdata['company-website'];
                          if (cName && cWebsite) {
                            this.setState({ step: 2 });
                            this.stepOne.current.scrollIntoView({ behavior: 'smooth' });
                            this.setState({ req: false });
                          } else {
                            this.setState({ req: true });
                            // this.myRef.current.scrollIntoView({ behavior: 'smooth' })
                          }
                        }}
                      >
                        Next
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          height={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    )}
                    {step == 2 && (
                      <button
                        className={'flex hover:bg-purple items-center bg-green rounded-5 px-10 py-5 text-14'}
                        type={'button'}
                        onClick={e => {
                          if (true) {
                            this.setState({ step: 3 });
                            this.stepOne.current.scrollIntoView({ behavior: 'smooth' });
                            this.setState({ req: false });
                          } else {
                            // this.myRef.current.scrollIntoView({ behavior: 'smooth' })
                          }
                        }}
                      >
                        Next
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={15}
                          height={15}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>
                <div className="loader-part flex w-full mt-20">
                  <div
                    className={`w-full border-t-2 ${step == 1 || step == 2 || step == 3 ? 'border-green' : 'border-gray-slider'} flex justify-center text-center relative`}
                  >
                    <div
                      className={`cursor-pointer w-20 h-20 flex justify-center items-center text-12 rounded-50p text-white  ${step == 1 || step == 2 || step == 3 ? 'bg-green ' : '  bg-gray-slider'} absolute -top-10`}
                    >
                      1
                    </div>
                  </div>
                  <div
                    className={`w-full border-t-2 ${step == 2 || step == 3 ? 'border-green' : 'border-gray-slider'} flex justify-center text-center relative`}
                  >
                    <div
                      className={`cursor-pointer w-20 h-20 flex justify-center items-center text-12 rounded-50p text-white  ${step == 2 || step == 3 ? 'bg-green ' : '  bg-gray-slider'} absolute -top-10`}
                    >
                      2
                    </div>
                  </div>
                  <div className={`w-full border-t-2 ${step == 3 ? 'border-green' : 'border-gray-slider'} flex justify-center text-center relative`}>
                    <div
                      className={`cursor-pointer w-20 h-20 flex justify-center items-center text-12 rounded-50p text-white  ${step == 3 ? 'bg-green ' : '  bg-gray-slider'} absolute -top-10`}
                    >
                      3
                    </div>
                  </div>
                </div>
                {step != 3 ? (
                  <div className={'mt-20 text-center text-12 text-black leading-15'}>*An email address is required in the form</div>
                ) : (
                  <div className={'mt-20 text-center'}>
                    <button
                      id={'offer-submit'}
                      className={'text-white bg-purple rounded-5 px-20 py-5 capitalize'}
                      onClick={e => {
                        let name = this.state.formdata['name'];
                        let email = this.state.formdata['email'];
                        if (name && email && this.emailValidation(email)) {
                          e.preventDefault();
                          this.onSubmit(e);
                          this.setState({ req: false });
                        } else {
                          this.setState({ req: true });
                        }
                      }}
                      type={'button'}
                    >
                      submit
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal} backUrl={'/social-media-marketing'}>
          One of our account managers will contact you and confirm your request. If you don’t receive an email from us within 24 hours please check
          your Spam Box.
        </Thanks>
      </>
    );
  }
}

export default CustomProposal;
